<template>
  <el-dialog :title="$t('pages.equipment.text363')" :visible.sync="errorVisible" width="700px" :before-close="handleClose" :close-on-click-modal="false">
    <div class="from-body">
      <el-form :model="ruleForm" ref="ruleForm" label-width="auto" class="demo-ruleForm">
        <el-form-item :label="$t('pages.equipment.text354')">
          <el-select v-model="ruleForm.lang" style="width:500px;" :placeholder="$t('public.text5')" disabled>
            <el-option :label="$t('pages.equipment.text340')" value="zh"/>
            <el-option :label="$t('pages.equipment.text341')" value="en"/>
            <el-option :label="$t('pages.equipment.text342')" value="ja"/>
            <el-option :label="$t('pages.equipment.text345')" value="hr"/>
            <el-option :label="$t('pages.equipment.text344')" value="pl"/>
            <el-option :label="$t('pages.equipment.text343')" value="pt"/>
            <el-option :label="$t('pages.equipment.text346')" value="de"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('menu.errCode')">
          <el-input v-model="ruleForm.errorCode" style="width:500px;" disabled/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text339')">
          <el-select v-model="ruleForm.hwType" style="width:500px;" disabled :placeholder="$t('public.text5')">
            <el-option :label="$t('pages.equipment.text178')" :value="10"/>
            <el-option :label="$t('pages.equipment.text202')" :value="15"/>
            <el-option :label="$t('pages.equipment.text203')" :value="20"/>
            <el-option :label="$t('pages.equipment.text204')" :value="25"/>
            <el-option :label="$t('pages.equipment.text205')" :value="30"/>
            <el-option :label="$t('pages.equipment.text206')" :value="35"/>
            <el-option :label="$t('pages.equipment.text207')" :value="40"/>
            <el-option :label="$t('pages.equipment.text208')" :value="45"/>
            <el-option :label="$t('pages.equipment.text347')" :value="50"/>
            <el-option :label="$t('pages.equipment.text348')" :value="55"/>
            <el-option :label="$t('pages.equipment.text349')" :value="60"/>
            <el-option :label="$t('pages.equipment.text350')" :value="65"/>
            <el-option :label="$t('pages.equipment.text362')" :value="70"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text355')">
          <el-input v-model="ruleForm.name" style="width:500px;" readonly/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text356')">
          <el-input v-model="ruleForm.forEngineer" style="width:500px;" readonly/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text357')">
          <el-input v-model="ruleForm.forUser" style="width:500px;" readonly/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text358')">
          <el-input v-model="ruleForm.solution" style="width:500px;" readonly/>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {}
    };
  },
  watch: {
    errorVisible(newValue) {
      if (newValue) {
        this.loadLang();
      }
    },
  },
  computed: {},
  mounted() {},
  props: ["errorVisible","errorRecord"],
  methods: {
    loadLang() {
      const that=this;
      that.ruleForm={
        "protocolId": that.errorRecord.protocolId,
        "errorCode": that.errorRecord.errorCode,
        "lang": that.errorRecord.lang,
      }
      that.request.errorLang(that.ruleForm).then((res) => {
        if (res.data!=null) {
          that.ruleForm.name=res.data.name;
          that.ruleForm.forEngineer=res.data.forEngineer;
          that.ruleForm.forUser=res.data.forUser;
          that.ruleForm.solution=res.data.solution;
          that.$forceUpdate();
        }
      });
    },
    //关闭弹窗
    handleClose() {
      this.$emit("dialogClose");
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 80%;
}
.firmware-content {
  display: flex;
}
.firmware-content a {
  margin-right: 20px;
}
</style>